const carouselItems = [
  {
    id: 1,
    title: '暑期档热播专题',
    desc: '2026暑期档最强片单，国产大剧扎堆上线，每日更新追不停',
    tag: '热门',
    img: 'https://readdy.ai/api/search-image?query=Summer%20entertainment%20banner%20with%20warm%20sunset%20gradient%20and%20abstract%20cinematic%20shapes%2C%20golden%20hour%20lighting%2C%20flowing%20organic%20ribbons%20in%20coral%20and%20amber%20tones%2C%20modern%20clean%20design%20with%20depth%2C%20horizontal%20banner%20layout%2C%20no%20text&width=1000&height=560&seq=carousel-01-summer&orientation=landscape',
  },
  {
    id: 2,
    title: '国产剧精选专题',
    desc: '评分最高的国产剧集，从古装到现代，部部经典值得收藏',
    tag: '精选',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20themed%20banner%20with%20traditional%20and%20modern%20Chinese%20aesthetic%20elements%2C%20warm%20red%20and%20gold%20color%20palette%2C%20flowing%20ink%20wash%20style%20with%20contemporary%20design%2C%20cinematic%20atmosphere%2C%20horizontal%20banner%20layout%2C%20clean%20composition%2C%20no%20text&width=1000&height=560&seq=carousel-02-chinese-drama&orientation=landscape',
  },
  {
    id: 3,
    title: '韩剧热播专题',
    desc: '最新韩剧一网打尽，甜蜜爱情与悬疑烧脑任你选择',
    tag: '热播',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20inspired%20banner%20with%20soft%20romantic%20atmosphere%20and%20modern%20urban%20aesthetic%2C%20warm%20peach%20and%20coral%20gradient%20tones%2C%20dreamy%20bokeh%20light%20effects%2C%20cinematic%20feel%2C%20horizontal%20banner%20layout%2C%20clean%20minimal%20design%2C%20no%20text&width=1000&height=560&seq=carousel-03-korean-drama&orientation=landscape',
  },
  {
    id: 4,
    title: '院线大片专题',
    desc: '最新上映的院线电影同步更新，动作科幻喜剧任你挑选',
    tag: '大片',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20banner%20with%20dramatic%20lighting%20and%20epic%20scale%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20abstract%20geometric%20shapes%20suggesting%20film%20and%20entertainment%2C%20horizontal%20banner%20layout%2C%20rich%20atmospheric%20depth%2C%20no%20text&width=1000&height=560&seq=carousel-04-movies&orientation=landscape',
  },
  {
    id: 5,
    title: '经典回顾专题',
    desc: '那些年我们一起追过的经典，重温感动与回忆',
    tag: '经典',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20film%20themed%20banner%20with%20vintage%20warm%20sepia%20and%20golden%20tones%2C%20soft%20film%20grain%20texture%2C%20elegant%20flowing%20shapes%2C%20timeless%20cinematic%20atmosphere%2C%20horizontal%20banner%20layout%2C%20clean%20nostalgic%20design%2C%20no%20text&width=1000&height=560&seq=carousel-05-classic&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            精选主题，发现更多精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href={`#carousel-${item.id}`}
              className="group block cursor-pointer"
            >
              <div className="relative aspect-[16/9] rounded-xl overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-sm md:text-base font-semibold text-background-50 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-background-50/75 line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}